import { render } from "./QuickStats.vue?vue&type=template&id=edbcd496&scoped=true"
import script from "./QuickStats.vue?vue&type=script&lang=js"
export * from "./QuickStats.vue?vue&type=script&lang=js"

import "./QuickStats.vue?vue&type=style&index=0&id=edbcd496&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edbcd496"]])

export default __exports__